import React from "react";
import VisibilityItemRow from "./VisibilityItemRow";
import { capitalizeFirstLetter } from "./utilities/index";
import { VisibilityArray, VisibilityCapitalized, MenuMap } from "./types";

type MenuVisibilityTableProps = {
  items: MenuMap;
  name: string;
  handleValueChange: (val: VisibilityArray, menuKey: string) => void;
};

const MenuVisibilityTable = ({
  items,
  name,
  handleValueChange,
}: MenuVisibilityTableProps) => {
  return (
    <table className="menu-visibility__table">
      <thead className="menu-visibility__thead">
        <tr>
          <th colSpan={2} className="menu-visibility__subheader">
            {capitalizeFirstLetter(name)}
          </th>
        </tr>
        <tr className="menu-visibility__tr">
          <th className="menu-visibility__td">Category</th>
          <th className="menu-visibility__td">Visibility</th>
        </tr>
      </thead>
      <tbody className="menu-visibility__tbody">
        {Object.keys(items).map((id, index) => {
          const item = items[id];
          const optionsSelectedFormatted: VisibilityArray = [];
          item.visibility_level?.forEach((item) => {
            optionsSelectedFormatted.push({
              value: item,
              label: capitalizeFirstLetter(item) as VisibilityCapitalized,
            });
          });
          return (
            <VisibilityItemRow
              itemName={item.name}
              menuKey={id}
              index={index}
              optionsSelectedFormatted={optionsSelectedFormatted}
              handleValueChange={handleValueChange}
              key={id}
            />
          );
        })}
      </tbody>
    </table>
  );
};

export default MenuVisibilityTable;
